import { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { useNavigate, useParams } from "react-router-dom";
import { CardHeader } from "react-bootstrap";
import ModalLoading from "../../components/modal/modalLoading.jsx";
import ModalInfo from "../../components/modal/modalInfo.jsx";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
import { dataMentoringDeleteDocument, dataMentoringDeleteEvt, dataMentoringDownloadDoc, dataMentoringDownloadUpload, dataMentoringEditMain, dataMentoringGetDocument, dataMentoringGetOne } from "../../config/apiSPA.js";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import ModalEditSelect2 from "../../components/modal/modalEditSelect2.jsx";
import ModalEditDate2 from "../../components/modal/modalEditDate2.jsx";
import ModalEditTime2 from "../../components/modal/modalEditTime2.jsx";
import ModalEditTextArea from "../../components/modal/modalEditTextArea.jsx";
import ModalUploadFile2 from "../../components/modal/modalUploadFile2.jsx";

function DetailMentoring() {
  const param = useParams();
  const [generalData, setGeneralData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [modalLoading, setModalLoading] = useState({ show: false, value: 0 });
  const [modalUploadFile, setModalUploadFile] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({ show: false, title: "Warning", text: "no text", id: null });
  const [modalConfirmEventDelete, setModalConfirmEventDelete] = useState({ show: false, title: "Warning", text: "no text", id: null });
  const [modalInfo, setModalInfo] = useState({ show: false, message: "no Message", title: "no title" });
  /////-----Edit Main State
  const [modalEditCompId, setModalEditCompId] = useState({ show: false, id: null, selected: null });
  const [modalEditActivityId, setModalEditActivityId] = useState({ show: false, id: null, selected: null });
  const [modalEditMpId, setModalEditMpId] = useState({ show: false, id: null, selected: null });
  const [modalEditInstructorId, setModalEditInstructorId] = useState({ show: false, id: null, selected: null });
  const [modalEditStartDate, setModalEditStartDate] = useState({ show: false, id: null, currentDate: null });
  const [modalEditEndDate, setModalEditEndDate] = useState({ show: false, id: null, currentDate: null });
  const [modalEditStartTime, setModalEditStartTime] = useState({ show: false, id: null, currentTime: null });
  const [modalEditEndTime, setModalEditEndTime] = useState({ show: false, id: null, currentTime: null });
  const [modalEditRemark, setModalEditRemark] = useState({ show: false, id: null, currentValue: null });
  /////-----End Edit Main State
  const [loadingValue, setLoadingValue] = useState(0);
  const [duplicateEventModal, setDuplicateEventModal] = useState(false);
  const navigate = useNavigate();

  /////-----Submit Edit
  const submitEdit = async (e, item, setModal) => {
    try {
      setModal((a) => ({ ...a, show: false }));
      const res = await dataMentoringEditMain({
        id: e.id,
        item: item,
        value: e.val,
      });

      setGeneralData(res.data);
    } catch (error) {
      if (error.status === 422) setModalInfo({ show: true, message: error.message, title: "Not Valid" });
    }
  };
  const submitCompId = (e) => submitEdit(e, "compId", setModalEditCompId);
  const submitActivityId = (e) => submitEdit(e, "activityId", setModalEditActivityId);
  const submitMpId = (e) => submitEdit(e, "mpId", setModalEditMpId);
  const submitInstructorId = (e) => submitEdit(e, "instructorId", setModalEditInstructorId);
  const submitStartDate = (e) => submitEdit(e, "startDate", setModalEditStartDate);
  const submitEndDate = (e) => submitEdit(e, "endDate", setModalEditEndDate);
  const submitStartTime = (e) => submitEdit(e, "startTime", setModalEditStartTime);
  const submitEndTime = (e) => submitEdit(e, "endTime", setModalEditEndTime);
  const submitRemark = (e) => submitEdit(e, "remark", setModalEditRemark);

  /////-----End Submit Edit
  const handleUploadFile = () => {
    setModalUploadFile({ show: true, title: "Choose Document", text: "Document like absensi, worksheet, TAF etc.", data: { id: param.id, val: null } });
  };

  const submitFile = async (file) => {
    try {
      const formData = new FormData();
      file.forEach((value, key) => {
        formData.append(key, value);
      });
      formData.append("id", param.id);
      setModalUploadFile({ ...modalUploadFile, show: false });
      setModalLoading({ ...modalLoading, title: "Uploading", show: true, text: "Please wait uploading in proggress..." });

      const res = await dataMentoringDownloadUpload(formData, (onProgress) => setLoadingValue(onProgress));
      setModalLoading({ ...modalLoading, show: false });
      setDocuments(res.data);
    } catch (error) {
      setModalLoading({ ...modalLoading, show: false });
      setModalInfo({ show: true, title: "Warning", message: error.message });
    }
  };
  const handleDownload = async (id) => {
    try {
      await dataMentoringDownloadDoc(id);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteFile = (id, fileName) => {
    setModalConfirm({ ...modalConfirm, show: true, text: "Are you sure want to delete: " + fileName + " ?", id: id });
  };

  const handleDeleteConfirmed = async () => {
    setModalConfirm({ ...modalConfirm, show: false });
    try {
      await dataMentoringDeleteDocument(modalConfirm.id);
      const res = await dataMentoringGetDocument(param.id);
      setDocuments(res.data);
    } catch (error) {
      setModalInfo({ show: true, message: error.message, title: "Error" });
    }
  };

  const editMain = (e, currentValue) => {
    switch (e) {
      case "compId":
        setModalEditCompId({ show: true, id: param.id, selected: currentValue });
        break;
      case "activityId":
        setModalEditActivityId({ show: true, id: param.id, selected: currentValue });
        break;
      case "mpId":
        setModalEditMpId({ show: true, id: param.id, selected: currentValue });
        break;
      case "instructorId":
        setModalEditInstructorId({ show: true, id: param.id, selected: currentValue });
        break;
      case "startDate":
        setModalEditStartDate({ show: true, id: param.id, currentDate: currentValue });
        break;
      case "endDate":
        setModalEditEndDate({ show: true, id: param.id, currentDate: currentValue });
        break;
      case "startTime":
        setModalEditStartTime({ show: true, id: param.id, currentTime: currentValue });
        break;
      case "endTime":
        setModalEditEndTime({ show: true, id: param.id, currentTime: currentValue });
        break;
      case "remark":
        setModalEditRemark({ show: true, id: param.id, currentValue: currentValue });
        break;
      default:
        break;
    }
  };

  const handleDeleteEvent = () => {
    setModalConfirmEventDelete({ show: true, title: "Warning", text: "Are you sure delete this mentoring data ?", id: null });
  };
  const handleDeleteEventConfirmed = () => {
    setModalConfirmEventDelete({ show: false, title: "Warning", text: "Are you sure delete this mentoring data ?", id: null });
    dataMentoringDeleteEvt(param.id).then((res) => navigate("/mentoring/data"));
  };

  useEffect(() => {
    dataMentoringGetOne(param.id).then((res) => setGeneralData(res.data));
    dataMentoringGetDocument(param.id).then((res) => setDocuments(res.data));
  }, []);

  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">MENTORING</a>
          </li>
          <li className="breadcrumb-item active">Detail</li>
        </ul>

        <h1 className="page-header">
          Mentoring Records <small></small>
        </h1>

        <hr className="mb-4" />

        <div className="row gx-4">
          <div className="col-lg-8">
            <Card className="mb-4">
              <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Mentoring Data</CardHeader>
              <CardBody>
                {generalData ? (
                  <>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Competency Title</div>
                          <div className="text-inverse text-opacity-50">{generalData.kodeComp.namaKompetensi}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("compId", generalData.kodeComp.id)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Competency Code</div>
                          <div className="text-inverse text-opacity-50">{generalData.kodeComp.kode}</div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Activity</div>
                          <div className="text-inverse text-opacity-50">{generalData.activity.name}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("activityId", generalData.activity.id)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Participant Name</div>
                          <div className="text-inverse text-opacity-50">{generalData.manpower.nama}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("mpId", generalData.manpower.id)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Participant NRP</div>
                          <div className="text-inverse text-opacity-50">{generalData.manpower.nrp}</div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Sub-Section</div>
                          <div className="text-inverse text-opacity-50">{generalData.manpower.subSection}</div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Instructor</div>
                          <div className="text-inverse text-opacity-50">{generalData.instructor.namaInstructor}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("instructorId", generalData.instructor.id)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Start Date</div>
                          <div className="text-inverse text-opacity-50">{DateFormat(generalData.startDate)}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("startDate", generalData.startDate)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">End Date</div>
                          <div className="text-inverse text-opacity-50">{DateFormat(generalData.endDate)}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("endDate", generalData.endDate)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Start Time</div>
                          <div className="text-inverse text-opacity-50">{generalData.startTime}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("startTime", generalData.startTime)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">End Time</div>
                          <div className="text-inverse text-opacity-50">{generalData.endTime}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("endTime", generalData.endTime)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="list-group list-group-flush">
                      <div className="list-group-item d-flex align-items-center">
                        <div className="flex-1 text-break">
                          <div className="text-theme">Remark</div>
                          <div className="text-inverse text-opacity-50">{generalData.remark}</div>
                        </div>
                        <div className="w-50px text-center">
                          <a href="#/" onClick={() => editMain("remark", generalData.remark)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-edit text-theme"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <p>no data</p>
                )}
              </CardBody>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card className="mb-4">
              <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
                <div className="flex-1">
                  <div>Resume</div>
                </div>
              </CardHeader>
              <CardBody>------------</CardBody>
            </Card>
          </div>

          <div className="col-lg-12">
            <Card className="mb-4">
              <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Document</CardHeader>
              <CardBody className="card-body pb-2">
                <div className="mb-2">
                  <div className="d-block d-lg-flex align-items-center">
                    <span onClick={() => handleUploadFile()} className="btn btn-outline-theme me-2 mb-1">
                      <i className="fa fa-fw fa-plus"></i>
                      <span>Add files...</span>
                    </span>
                  </div>
                </div>
              </CardBody>
              <table className="table table-card mb-0 fs-13px">
                <thead>
                  <tr className="fs-12px">
                    <th className="pt-2 pb-2 w-25">FILENAME</th>
                    <th className="pt-2 pb-2 w-25">SIZE</th>
                    <th className="pt-2 pb-2 w-25">UPLOADED</th>
                    <th className="pt-2 pb-2 w-25">ACTION</th>
                  </tr>
                </thead>
                <tbody className="files">
                  {documents.length > 0 ? (
                    documents.map((document) => (
                      <tr key={document.id}>
                        <td className="align-middle">{document.fileName}</td>
                        <td className="align-middle">{document.size}</td>
                        <td className="align-middle">{DateFormat(document.createdAt)}</td>
                        <td>
                          <a href="#/" onClick={() => handleDeleteFile(document.id, document.fileName)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-trash-alt text-danger"></i>
                          </a>
                          <a href="#/" onClick={() => handleDownload(document.id)} className="btn btn-outline-default btn-sm">
                            <i className="fas fa-download text-theme"></i>
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="empty-row">
                      <td colSpan="4" className="text-center p-3">
                        <div className="text-gray-300 mb-2">
                          <i className="fa fa-file-archive fa-3x"></i>
                        </div>
                        No file uploaded
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Card>
            <a onClick={() => handleDeleteEvent()} href="#/" className="text-danger">
              Delete
            </a>
          </div>
        </div>
      </div>
      <ModalUploadFile2 show={modalUploadFile.show} onHide={() => setModalUploadFile(false)} submitClick={submitFile} />
      <ModalLoading show={modalLoading.show} title={modalLoading.title} text={modalLoading.text} value={loadingValue} onHide={() => setModalLoading({ ...modalLoading, show: false })} />
      <ModalInfo show={modalInfo.show} clicked={() => setModalInfo({ ...modalInfo, show: false })} onHide={() => setModalInfo({ ...modalInfo, show: false })} theme={"danger"} title={modalInfo.title} text={modalInfo.message} />
      <ModalConfirm show={modalConfirm.show} clicked={() => handleDeleteConfirmed()} onHide={() => setModalConfirm({ ...modalConfirm, show: false })} title={modalConfirm.title} text={modalConfirm.text} theme={"danger"} />
      <ModalConfirm
        show={modalConfirmEventDelete.show}
        clicked={() => handleDeleteEventConfirmed()}
        onHide={() => setModalConfirmEventDelete({ ...modalConfirmEventDelete, show: false })}
        title={modalConfirmEventDelete.title}
        text={modalConfirmEventDelete.text}
        theme={"danger"}
      />
      {/* /////-----Modal Edit Main */}
      <ModalEditSelect2
        show={modalEditCompId.show}
        onHide={() => setModalEditCompId((a) => ({ ...a, show: false }))}
        options={{ title: "Competency Title Edit", text: "Please select competency title" }}
        id={modalEditCompId.id}
        selected={modalEditCompId.selected}
        selector={"competency-code"}
        submitClick={submitCompId}
      />
      <ModalEditSelect2
        show={modalEditActivityId.show}
        onHide={() => setModalEditActivityId((a) => ({ ...a, show: false }))}
        options={{ title: "Activity Edit", text: "Please select mentoring activity type" }}
        id={modalEditActivityId.id}
        selected={modalEditActivityId.selected}
        selector={"activity-mentoring"}
        submitClick={submitActivityId}
      />
      <ModalEditSelect2
        show={modalEditMpId.show}
        onHide={() => setModalEditMpId((a) => ({ ...a, show: false }))}
        options={{ title: "Participant Edit", text: "Please select mentoring participant" }}
        id={modalEditMpId.id}
        selected={modalEditMpId.selected}
        selector={"manpower"}
        submitClick={submitMpId}
      />
      <ModalEditSelect2
        show={modalEditInstructorId.show}
        onHide={() => setModalEditInstructorId((a) => ({ ...a, show: false }))}
        options={{ title: "Instructor Edit", text: "Please select mentoring instructor" }}
        id={modalEditInstructorId.id}
        selected={modalEditInstructorId.selected}
        selector={"instructor"}
        submitClick={submitInstructorId}
      />
      <ModalEditDate2 show={modalEditStartDate.show} onHide={() => setModalEditStartDate((a) => ({ ...a, show: false }))} id={modalEditStartDate.id} currentDate={modalEditStartDate.currentDate} submitClick={submitStartDate} />
      <ModalEditDate2 show={modalEditEndDate.show} onHide={() => setModalEditEndDate((a) => ({ ...a, show: false }))} id={modalEditEndDate.id} currentDate={modalEditEndDate.currentDate} submitClick={submitEndDate} />
      <ModalEditTime2 show={modalEditStartTime.show} onHide={() => setModalEditStartTime((a) => ({ ...a, show: false }))} id={modalEditStartTime.id} currentTime={modalEditStartTime.currentTime} submitClick={submitStartTime} />
      <ModalEditTime2 show={modalEditEndTime.show} onHide={() => setModalEditEndTime((a) => ({ ...a, show: false }))} id={modalEditEndTime.id} currentTime={modalEditEndTime.currentTime} submitClick={submitEndTime} />
      <ModalEditTextArea show={modalEditRemark.show} onHide={() => setModalEditRemark((a) => ({ ...a, show: false }))} id={modalEditRemark.id} currentValue={modalEditRemark.currentValue} submitClick={submitRemark} />
      {/* /////-----End Modal Edit Main */}
      <ModalConfirm show={duplicateEventModal} clicked={() => setDuplicateEventModal(false)} onHide={() => setDuplicateEventModal(false)} title={"Warning"} text={"This event already exist"} theme={"danger"} />
    </>
  );
}

export default DetailMentoring;
